var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col align-center h-full px-10"},[_c('h1',{staticClass:"sm:text-3xl lg:text-4xl font-bold title-font text-default mb-4"},[_vm._v("Mes invitations")]),_c('InvitationList',{attrs:{"show-all":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }